/**
 * PipelineActivityTrail — the pipeline audit-trail row list and its states
 * (SE-5504). Shared by the card-scoped drawer trail and the per-pipeline log.
 * @module features/player-kanban/components/molecules/PipelineActivityTrail
 */

export { default } from "./PipelineActivityTrailView";
export type { PipelineActivityTrailViewProps } from "./PipelineActivityTrailView";
